import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarComponent } from './avatar.component';
import { AvailabilityIndicatorComponent } from './availability-indicator/availability-indicator.component';
import { TooltipModule } from '@intranet/components/tooltip/tooltip.module';

@NgModule({
    declarations: [AvatarComponent, AvailabilityIndicatorComponent],
    imports: [
        CommonModule,
        TooltipModule,
    ],
    exports: [AvatarComponent]
})
export class AvatarModule {}